export type BarChartMode = "monthly" | "quarterly" | "yearly";
export const BarChartModes = ["monthly", "quarterly", "yearly"];

export type Range = {
  startDate: Date;
  endDate: Date;
};

export type BarChartItem = {
  startDate: Date;
  endDate: Date;
  value: number;
  value2: number;
  label: string;
  id: string;
};
